var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidsizesuvBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.389,
    height: 66.486,
    viewBox: "0 0 119.389 66.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "midsizesuv-blue-icon",
    transform: "translate(-68 -576.514)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Mid_Size_SUV",
    "data-name": "Mid Size SUV",
    transform: "translate(80 639)",
    fill: "#04a8e8",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MID SIZE SUV")), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M1552.85,2452.49c-6.732.766-9.783-4.2-6.841-10.96a7.453,7.453,0,0,0,.95-2.233c.4-3.752,2.755-5.463,6.262-6.176a154.405,154.405,0,0,1,18.608-2.716,17.463,17.463,0,0,0,9.836-3.494c9.969-7.884,21.431-10.483,33.9-10.166,9.105.231,18.234-.266,27.322.594,2.228.209,5.182-.238,5.309,3.51.016.5.942.995,1.487,1.44a76.814,76.814,0,0,0,6.937,5.528c3.2,2.048,4.827,4.646,4.644,8.5-.1,2.08.876,3.7,2.081,5.576,1.669,2.594.794,6.266-.321,9.257-.9,2.413-3.424,1.517-5.344,1.642-1.169.077-2.347.015-3.379.015-.962-1.335-.854-2.694-1.157-3.94a11.876,11.876,0,0,0-11.75-8.952c-4.664-.008-11.091,5.125-10.986,10.082.051,2.445-1.2,2.856-3.336,2.846q-23.63-.1-47.263.007c-2.235.011-2.99-.728-3.412-2.928-1.2-6.209-5.811-10-11.582-9.952s-9.972,3.888-11.28,10.268A23.59,23.59,0,0,1,1552.85,2452.49Zm58.105-32.1c-9.525-1.166-17.861.92-25.159,7.632,2.5.144,3.953,1.151,3.763,3.371,3.474,0,6.657.151,9.819-.042,3.272-.2,7.314.906,9.611-1.012,2.332-1.948,1.273-6.2,2.075-9.365C1611.092,2420.874,1611.026,2420.746,1610.955,2420.392Zm19.235,9.68c.52-7.7-1.125-9.589-8.415-9.9-1.767-.074-3.54,0-5.309-.067a2.037,2.037,0,0,0-2.362,2.022c-.373,2.773-1.04,5.523-.772,8.6A113,113,0,0,0,1630.19,2430.072Zm24.362-1.156c-3.548-2.629-6.146-6.674-10.93-7.212C1646.28,2425.664,1649.446,2428.833,1654.552,2428.916Zm-17.068.058a11.69,11.69,0,0,0-5.811-6.179c.567,2.7,1.035,4.931,1.5,7.141C1634.792,2430.044,1636.2,2430.316,1637.484,2428.974Z",
    transform: "translate(-1476.889 -1840.205)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M1574.469,2453.153c-.064,4.856-4.3,9.171-8.929,9.085-4.574-.085-8.936-4.613-8.907-9.245a9.177,9.177,0,0,1,9.058-9A8.908,8.908,0,0,1,1574.469,2453.153Z",
    transform: "translate(-1475.957 -1841.619)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M1646.65,2462.215c-4.654.024-8.8-4.3-8.828-9.221-.037-5.645,3.34-9.027,8.957-8.973a9.122,9.122,0,0,1,8.933,9.1C1655.645,2457.807,1651.274,2462.193,1646.65,2462.215Z",
    transform: "translate(-1480.166 -1841.62)",
    fill: "#04a8e8",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidsizesuvBlueIcon);
export default __webpack_public_path__ + "static/media/midsizesuv-blue-icon.6c2d77e326d56f93b84820ecec25f15c.svg";
export { ForwardRef as ReactComponent };